(() => {
  const formattedPlaceholder = '(514) 555-1234';
  const messages = {
    fr: 'Veuillez entrer un numero de telephone valide (ex: (514) 555-1234)',
    en: 'Please enter a valid phone number (ex: (514) 555-1234)'
  };

  const getMessage = () => {
    const lang = (document.documentElement.lang || '').toLowerCase();
    return lang.startsWith('fr') ? messages.fr : messages.en;
  };

  const getDigits = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  };

  const isValidPhone = (value) => /^[2-9]\d{2}[2-9]\d{6}$/.test(getDigits(value));

  const formatPhone = (value) => {
    const digits = getDigits(value);
    if (digits.length !== 10) return String(value || '').trim();
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const validatePhoneInput = (input) => {
    const value = input.value.trim();
    if (!value) {
      input.setCustomValidity('');
      return !input.required;
    }

    if (!isValidPhone(value)) {
      input.setCustomValidity(getMessage());
      return false;
    }

    input.value = formatPhone(value);
    input.setCustomValidity('');
    return true;
  };

  const initPhoneInput = (input) => {
    if (!input || input.dataset.phoneNormalizerReady === 'true') return;

    input.dataset.phoneNormalizerReady = 'true';
    input.inputMode = 'tel';
    if (!input.autocomplete) input.autocomplete = 'tel';
    if (!input.placeholder) input.placeholder = formattedPlaceholder;

    input.addEventListener('blur', () => validatePhoneInput(input));
    input.addEventListener('input', () => {
      if (!input.value.trim() || isValidPhone(input.value)) {
        input.setCustomValidity('');
      }
    });
  };

  const initAllPhoneInputs = (root = document) => {
    root.querySelectorAll('input[type="tel"]').forEach(initPhoneInput);
  };

  const bootPhoneNormalizer = () => {
    initAllPhoneInputs();

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const invalidPhone = [...form.querySelectorAll('input[type="tel"]')]
        .find((input) => !validatePhoneInput(input));

      if (invalidPhone) {
        event.preventDefault();
        invalidPhone.reportValidity();
      }
    }, true);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('input[type="tel"]')) initPhoneInput(node);
          initAllPhoneInputs(node);
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPhoneNormalizer);
  } else {
    bootPhoneNormalizer();
  }
})();